import React from 'react';

class DeleteEverything extends React.Component {

    static defaultProps = {
        afterSubmit: () => null
    };

    state = {
        value: '',
        error: ''
    };

    onChangeValue = ({currentTarget: { value }}) => {

        this.setState({ value });
    };

    onSubmit = e => {

        e.preventDefault();

        this.props.changeCover(true, () => {

            this.props.onSubmit()
                .then(() => {
                    this.props.changeCover(false, this.props.afterSubmit);
                })
                .catch(({ message: error }) => {

                    this.setState({ error }, () => {
                        this.props.changeCover(false);
                    });
                });
        });
    };

    render() {

        return (
            <form onSubmit={this.onSubmit}>

                <div className="form-group">

                    <label htmlFor="delete-everything">{this.props.label}</label>
                    <p className="text-muted">
                        {this.props.children}
                    </p>

                    {this.state.error ? (
                        <div className="well">
                            {this.state.error}
                        </div>
                    ) : null}

                    <input
                        type="text"
                        className="form-control"
                        id="delete-everything"
                        placeholder={`Type "DELETE EVERYTHING" to confirm`}
                        value={this.state.value}
                        onChange={this.onChangeValue}
                        required
                    />
                </div>

                <div className="form-group">

                    <div className="clearfix">
                        <button
                            type="submit"
                            className="btn btn-danger pull-right"
                            disabled={this.state.value !== 'DELETE EVERYTHING'}
                        >
                            Delete Everything
                        </button>

                    </div>
                </div>

            </form>
        );
    }
}

export default DeleteEverything;


// WEBPACK FOOTER //
// ./src/components/_global/DeleteEverything.jsx